
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import PropertyValue from '@/components/main/PropertyValue.vue'

    @Component({
        emits: ['locationChanged'],
        components: {
            PropertyValue,
        },
    })
    export default class AreaInforamtion extends Vue {

        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public area: any;
        @Prop({ default: null }) public scenario: any;
        
        private setLocation(location: any) {
            this.$emit('locationChanged', location);
        }
    }
